import React from "react";
import ReactDOM from "react-dom/client";
import "shepherd.js/dist/css/shepherd.css";
import "@/styles/aurora-shepherd.css";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
